angular
  .module("digitalLeasing.module")
  .component("informazioniPratica", {
    templateUrl: "ng/components/digitalLeasing/checkList/informazioniPratica/informazioniPratica.view.html",
    bindings: {
      model: "=",
      infoPage: "&",
      snapshot: '<',
      portalRunned: "<",
      controlIban: '&'

    },
    controllerAs: "informazioniPraticaCtrl",
    controller: InformazioniPraticaController


  });

function InformazioniPraticaController(
  $portalService,
  $rootScope
) {
  var self = this;
  self.$portalService = $portalService;
  self.$onInit = function (
    $rootScope
  ) {



    if (($portalService.isAru() && !self.snapshot) || self.portalRunned == "ILEAF_ARU") {
      self.placeholderTextArea = 'LBL_FIN_NOTES_ALBA_PLACEHOLDER_1000'
    } else {
      self.placeholderTextArea = 'LBL_PLACEHOLDER_NOTE_RIFIUTO'
    }

    if (getWizardMap(self.model.viewIndex) == "M17") {
      self.isContractSignatureMap = true;
      self.callInfoPage();
    } else {
      self.isContractSignatureMap = false;
    }

  }

  self.callInfoPage = function () {
    self.infoPage();
  }

  var getWizardMap = function (viewIndex) {
    return $rootScope.wizardMap
      .find(function (element) {
        return element.index == viewIndex
      }).viewName
  }

  self.controlloIban = function () {
    self.controlIban();
  }


}